import styled from 'styled-components';

/**
 * Composants réutilisables pour les sections collapsibles
 * Utilisés dans les sections Photo et Contact du modal
 */

export const CollapsibleHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  user-select: none;
  margin: 0 0 0.75rem 0;
  padding: 0;
  
  &:hover {
    opacity: 0.8;
  }
`;

export const CollapsibleTitle = styled.h3`
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  font-weight: ${({ theme }) => theme.typography.weights.semibold};
  color: ${({ theme }) => theme.colors.text};
  margin: 0;
  padding: 0;
`;

export const CollapseIcon = styled.div<{ $isExpanded: boolean }>`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.primary};
  font-size: 14px;
  transition: transform 0.2s;
  transform: ${({ $isExpanded }) => $isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'};
`;

export const CollapsibleContent = styled.div<{ $isExpanded: boolean }>`
  display: ${({ $isExpanded }) => $isExpanded ? 'grid' : 'none'};
  grid-template-rows: 1fr;
  
  > * {
    overflow: hidden;
  }
`;

export const MissingText = styled.div`
  color: #e53e3e;
  font-size: 13px;
  font-style: italic;
  padding: 4px 0 0 0;
  
  @media (max-width: 768px) {
    font-size: 12px;
  }
`;
